import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { type ComponentProps, useState } from 'react';

import { Button } from '../Button/Button';
import { DialogCloseButton } from '../DialogCloseButton/DialogCloseButton';
import { PhotoEvidenceList } from '../PhotoEvidenceList/PhotoEvidenceList';

const DEFAULT_DIALOG_TITLE = 'Photo & Video Evidence';
const DEFAULT_SHOW_MORE_LABEL = 'Show more images & videos';
const DEFAULT_CLOSE_BUTTON_ARIA_LABEL = 'close';

export const PhotoEvidenceDialogGallery = ({
  labels,
  slotProps,
  showMoreImages,
}: {
  labels?: {
    closeButtonAriaLabel?: string;
    dialogTitle?: React.ReactNode;
    showMoreButton?: React.ReactNode;
  };
  slotProps: {
    photoList: ComponentProps<typeof PhotoEvidenceList>;
  };
  showMoreImages: boolean;
}) => {
  const [photoModalOpen, setPhotoModalOpen] = useState(false);
  const showMoreButtonLabel = labels?.showMoreButton ?? DEFAULT_SHOW_MORE_LABEL;
  const closeButtonAriaLabel = labels?.closeButtonAriaLabel ?? DEFAULT_CLOSE_BUTTON_ARIA_LABEL;

  return (
    <>
      {showMoreImages ? (
        <Button size="medium" variant="secondary" data-testid="show-more-media" onClick={() => setPhotoModalOpen(true)}>
          {showMoreButtonLabel}
        </Button>
      ) : null}
      <Dialog
        open={photoModalOpen}
        onClose={() => setPhotoModalOpen(false)}
        maxWidth="lg"
        aria-labelledby="evidence-photos"
      >
        <DialogTitle id="evidence-photos">{labels?.dialogTitle ?? DEFAULT_DIALOG_TITLE}</DialogTitle>
        <DialogCloseButton ariaLabel={closeButtonAriaLabel} onClick={() => setPhotoModalOpen(false)} />
        <DialogContent>
          <PhotoEvidenceList openOnClick {...slotProps.photoList} />
        </DialogContent>
      </Dialog>
    </>
  );
};
